import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, IntentProjectHclArgs } from "types/generated";

type GetIntentProjectHclVariables = {
  id: string;
} & IntentProjectHclArgs;

export const GET_INTENT_PROJECT_HCL: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "name" | "hcl"> },
  GetIntentProjectHclVariables
> = gql`
  query GetIntentProjectHcl($id: ID!, $page: Int, $pageSize: Int) {
    intentProject(id: $id) {
      id
      name
      hcl(page: $page, pageSize: $pageSize) {
        hcl
        hasMore
      }
    }
  }
`;
